import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bmwicon_车漆-26",
  "use": "icon-bmwicon_车漆-26-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-bmwicon_车漆-26\"><path d=\"M20,1.57a18.43,18.43,0,0,0,0,36.86c6.48,0-4-7.38,7.37-7.38A10.88,10.88,0,0,0,38.43,20,18.45,18.45,0,0,0,20,1.57ZM8,19.08a2.77,2.77,0,1,1,2-.81A2.77,2.77,0,0,1,8,19.08Zm6.44-6.45a2.77,2.77,0,1,1,2-.81A2.77,2.77,0,0,1,14.46,12.63Zm11.06,0a2.77,2.77,0,1,1,2.76-2.76A2.77,2.77,0,0,1,25.52,12.63ZM32,19.08a2.77,2.77,0,1,1,2.77-2.76A2.77,2.77,0,0,1,32,19.08Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol